import { http } from '../index'

// 系统公告接口类型定义
export interface Announcement {
  id: number
  title: string
  content: string
  type: 'info' | 'success' | 'warning' | 'error'
  status: 'draft' | 'published' | 'offline'
  publish_time: string | null
  offline_time: string | null
  is_top: boolean
  sort: number
  created_by: number
  creator_name: string
  updated_by: number
  updater_name: string
  created_at: string
  updated_at: string
}

export interface AnnouncementListParams {
  page?: number
  per_page?: number
  keyword?: string
  type?: string
  status?: string
}

export interface AnnouncementCreateData {
  title: string
  content: string
  type: 'info' | 'success' | 'warning' | 'error'
  status: 'draft' | 'published' | 'offline'
  publish_time?: string | null
  offline_time?: string | null
  is_top?: boolean
  sort?: number
}

export interface AnnouncementUpdateData extends Partial<AnnouncementCreateData> {}

export const announcementApi = {
  /**
   * 获取公告列表
   */
  list: (params: AnnouncementListParams = {}) => {
    return http.get<{
      list: Announcement[]
      current_page: number
      per_page: number
      total: number
      last_page: number
    }>('system/announcements', { params })
  },

  /**
   * 获取公告详情
   */
  detail: (id: number) => {
    return http.get<Announcement>(`system/announcements/${id}`)
  },

  /**
   * 创建公告
   */
  create: (data: AnnouncementCreateData) => {
    return http.post<Announcement>('system/announcements', data)
  },

  /**
   * 更新公告
   */
  update: (id: number, data: AnnouncementUpdateData) => {
    return http.put<Announcement>(`system/announcements/${id}`, data)
  },

  /**
   * 删除公告
   */
  delete: (id: number) => {
    return http.delete(`system/announcements/${id}`)
  },
}

export default announcementApi
